import * as React from 'react';

// API
import apibridge from '../apibridge';

// UTILS
import { validationErrorsToString } from '../utils';

// REDUX
import { useAppSelector } from '../store';

// PACKAGES
import { Form, Formik } from 'formik';

// COMPONENTS
import Button from './Button';
import FileUpload from './FileUpload';

// TYPES
import { closeModalType } from './GlobalModal';

interface EditProfileImageTypes {
	closeModal?: closeModalType;
	isUpdated?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditProfileImage: React.FC<EditProfileImageTypes> = ({ closeModal, isUpdated }) => {
	// Check if Organisation is active
	const isOrganisationActive = useAppSelector((state) => state.user.isOrganisationActive);

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const updateProfileImage = async (values: any) => {
		setIsLoading(true);

		const response = await apibridge.postAccountEditProfileImage({ imageFile: values.profileImageName });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (isUpdated) {
				isUpdated(true);
			}

			if (closeModal) {
				closeModal();
			}
		}
	};
	return (
		<>
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<Formik onSubmit={updateProfileImage} initialValues={{}}>
					{(formik) => {
						return (
							<Form translate="yes">
								<div className="form-group">
									<label htmlFor="profileImageName">Update profile picture</label>

									<FileUpload
										name="profileImageName"
										onChange={(val: string) => formik.setFieldValue('profileImageName', val)}
										multiple={false}
										maxSizeMb={5}
										imagesOnly={true}
										disabled={!isOrganisationActive}
									></FileUpload>
								</div>

								<div className="actions">
									<Button
										type="submit"
										className="btn-primary full-width"
										disabled={isLoading || !isOrganisationActive}
									>
										Submit
									</Button>
								</div>
							</Form>
						);
					}}
				</Formik>
			)}
		</>
	);
};

export default EditProfileImage;
